import { MaterialDelivery } from 'classes';
import ODataUtil from 'utils/ODataUtil';

const apiEndpoint = "/Material";

const getMaterialDelieries = async function getMaterialDelieries(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = MaterialDelivery;
  const endpoint = apiEndpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  return data;
}

export { getMaterialDelieries };